(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-sliderepa"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mq-collection-carousel')) {
  customElements.define('mq-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.controller = new AbortController();
      this.nextPage = Number.parseInt(this.dataset.nextPage || '', 10) || null;
      this.productLimit = Number.parseInt(this.dataset.productLimit || '', 10) || 12;
      this.loadingPage = false;
      const signal = this.controller.signal;
      const activate = () => {
        this.initialize();
        this.loadNextPage();
      };

      this.addEventListener('pointerdown', activate, { capture: true, signal });
      this.addEventListener('focusin', activate, { capture: true, signal });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.initialize();
          this.loadNextPage();
          this.observer?.disconnect();
        }, { rootMargin: '100px 0px' });
        this.observer.observe(this);
      } else {
        this.initialize();
      }
    }

    async loadNextPage() {
      if (this.loadingPage || !this.nextPage || !this.dataset.sourceUrl || !this.track) return;
      if (this.track.children.length >= this.productLimit) {
        this.nextPage = null;
        this.refreshNav?.();
        return;
      }

      this.loadingPage = true;
      this.setAttribute('aria-busy', 'true');

      try {
        const url = new URL(this.dataset.sourceUrl, window.location.origin);
        url.searchParams.set('view', 'mq-carousel-items');
        url.searchParams.set('page', String(this.nextPage));

        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.controller.signal,
        });
        if (!response.ok) throw new Error(`Carousel request failed: ${response.status}`);

        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const page = documentFragment.querySelector('[data-mq-carousel-page]');
        if (!page) throw new Error('Carousel response is missing its product list.');

        const loadedIds = new Set(
          [...this.track.querySelectorAll('[data-product-id]')].map((item) => item.dataset.productId)
        );
        const remainingSlots = Math.max(0, this.productLimit - this.track.children.length);
        const items = [...page.querySelectorAll(':scope > [data-product-id]')]
          .filter((item) => !loadedIds.has(item.dataset.productId))
          .slice(0, remainingSlots);

        items.forEach((item) => this.track.appendChild(item));
        this.nextPage = Number.parseInt(page.dataset.nextPage || '', 10) || null;
        if (this.track.children.length >= this.productLimit) this.nextPage = null;
        this.refreshNav?.();
      } catch (error) {
        if (error.name !== 'AbortError') this.nextPage = null;
      } finally {
        this.loadingPage = false;
        this.removeAttribute('aria-busy');
      }
    }

    initialize() {
      if (this.initialized) return;
      this.track = this.querySelector('.fcs__track');
      const viewport = this.querySelector('.fcs__viewport');
      const prev = this.querySelector('.fcs__nav--prev');
      const next = this.querySelector('.fcs__nav--next');
      if (!this.track || !viewport || !prev || !next) return;

      this.initialized = true;
      const track = this.track;
      const signal = this.controller.signal;
      const listen = (el, name, handler, options = {}) => el.addEventListener(name, handler, { ...options, signal });

      this.refreshNav = () => {
        const visible = Number.parseFloat(getComputedStyle(track).getPropertyValue('--per-view')) || 4;
        const show = track.children.length > visible || Boolean(this.nextPage);
        prev.toggleAttribute('hidden', !show);
        next.toggleAttribute('hidden', !show);
      };
      this.refreshNav();
      listen(window, 'resize', this.refreshNav);

      const slideWidth = () => {
        const gap = Number.parseFloat(getComputedStyle(track).getPropertyValue('gap')) || 16;
        return track.children[0].getBoundingClientRect().width + gap;
      };
      let animating = false;
      const move = (direction) => {
        this.loadNextPage();
        if (animating || track.children.length < 2) return;
        animating = true;
        const width = slideWidth();
        let finished = false;
        const finish = (event) => {
          if (event && (event.target !== track || event.propertyName !== 'transform')) return;
          if (finished) return;
          finished = true;
          clearTimeout(this.animationTimer);
          track.removeEventListener('transitionend', finish);
          if (direction > 0) track.appendChild(track.children[0]);
          track.style.transition = 'none';
          track.style.transform = 'translateX(0)';
          animating = false;
        };
        if (direction < 0) {
          track.style.transition = 'none';
          track.insertBefore(track.lastElementChild, track.firstElementChild);
          track.style.transform = `translateX(-${width}px)`;
          void track.offsetHeight;
        }
        listen(track, 'transitionend', finish);
        track.style.transition = 'transform var(--transition) ease';
        track.style.transform = direction > 0 ? `translateX(-${width}px)` : 'translateX(0)';
        this.animationTimer = setTimeout(finish, 450);
      };
      listen(prev, 'click', () => move(-1));
      listen(next, 'click', () => move(1));

      let dragging = false;
      let startX = 0;
      let deltaX = 0;
      let moved = false;
      listen(viewport, 'pointerdown', (event) => {
        if (animating || event.button > 0) return;
        dragging = true;
        moved = false;
        startX = event.clientX;
        deltaX = 0;
        track.style.transition = 'none';
      });
      listen(viewport, 'pointermove', (event) => {
        if (!dragging || animating) return;
        deltaX = event.clientX - startX;
        if (Math.abs(deltaX) > 6) moved = true;
        if (moved) {
          event.preventDefault();
          track.style.transform = `translateX(${deltaX}px)`;
        }
      });
      const endDrag = () => {
        if (!dragging) return;
        dragging = false;
        if (moved && Math.abs(deltaX) > slideWidth() * 0.25) move(deltaX < 0 ? 1 : -1);
        else {
          track.style.transition = 'transform var(--transition) ease';
          track.style.transform = 'translateX(0)';
        }
      };
      listen(viewport, 'pointerup', endDrag);
      listen(viewport, 'pointerleave', endDrag);
      listen(viewport, 'pointercancel', () => {
        dragging = false;
        moved = false;
        track.style.transform = 'translateX(0)';
      });
      listen(viewport, 'click', (event) => {
        if (moved) {
          event.preventDefault();
          event.stopPropagation();
          moved = false;
        }
      }, { capture: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      clearTimeout(this.animationTimer);
      if (this.track) {
        this.track.style.transition = 'none';
        this.track.style.transform = 'translateX(0)';
      }
      this.controller = null;
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('[data-slider]');
  if (!slider) return;

  const slidesContainer = slider.querySelector('[data-slides]');
  const tabs = slider.querySelectorAll('[data-tabs] .slider-tab');
  const dots = slider.querySelectorAll('[data-dots] .slider-dot');

  function goToSlide(index) {
    slidesContainer.style.transform = `translateX(-${index * 100}%)`;
    tabs.forEach(tab => tab.classList.remove('active'));
    dots.forEach(dot => dot.classList.remove('active'));
    if (tabs[index]) tabs[index].classList.add('active');
    if (dots[index]) dots[index].classList.add('active');
  }

  tabs.forEach(tab => {
    tab.addEventListener('click', () => goToSlide(Number(tab.dataset.index)));
  });

  dots.forEach(dot => {
    dot.addEventListener('click', () => goToSlide(Number(dot.dataset.index)));
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tire-size-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const sortValues = (values) => {
    return [...new Set(values.filter(Boolean))].sort((a, b) =>
      a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })
    );
  };

  const filterProducts = (products, state) => {
    return products.filter((product) => {
      if (state.width && product.width !== state.width) return false;
      if (state.profile && product.profile !== state.profile) return false;
      if (state.rim && product.rim !== state.rim) return false;
      return true;
    });
  };

  const buildOptions = (select, values, placeholder, currentValue, disabled) => {
    const safeCurrent = values.includes(currentValue) ? currentValue : '';
    select.replaceChildren();

    const placeholderOption = document.createElement('option');
    placeholderOption.value = '';
    placeholderOption.textContent = placeholder;
    select.appendChild(placeholderOption);

    values.forEach((value) => {
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      select.appendChild(option);
    });

    select.disabled = disabled;
    select.value = safeCurrent;
  };

  const initializeFinder = (root, products) => {
    if (root.dataset.finderReady === 'true') return;

    const form = root.querySelector('[data-tire-finder-form]');
    const widthSelect = root.querySelector('[data-tire-width]');
    const profileSelect = root.querySelector('[data-tire-profile]');
    const rimSelect = root.querySelector('[data-tire-rim]');
    const submitButton = root.querySelector('[data-tire-submit]');
    const statusNode = root.querySelector('[data-tire-status]');
    if (!form || !widthSelect || !profileSelect || !rimSelect || !submitButton || !statusNode) return;

    if (!Array.isArray(products) || !products.length) {
      statusNode.textContent = 'No encontramos medidas disponibles. Puedes revisar la colección completa.';
      root.setAttribute('aria-busy', 'false');
      return;
    }

    root.dataset.finderReady = 'true';
    root.setAttribute('aria-busy', 'false');
    const collectionUrl = root.dataset.collectionUrl || '';
    const defaultButtonLabel = root.dataset.buttonLabel || 'Ver neumáticos';
    const state = { width: '', profile: '', rim: '' };
    const placeholders = {
      width: widthSelect.dataset.placeholder || 'Selecciona ancho',
      profile: profileSelect.dataset.placeholder || 'Selecciona perfil',
      rim: rimSelect.dataset.placeholder || 'Selecciona aro',
    };
    const allWidths = sortValues(products.map((product) => product.width));

    const render = () => {
      if (!allWidths.includes(state.width)) state.width = '';
      buildOptions(widthSelect, allWidths, placeholders.width, state.width, false);

      const profiles = state.width
        ? sortValues(filterProducts(products, { width: state.width }).map((product) => product.profile))
        : [];
      if (!profiles.includes(state.profile)) state.profile = '';
      buildOptions(profileSelect, profiles, placeholders.profile, state.profile, !state.width);

      const rims = state.width && state.profile
        ? sortValues(filterProducts(products, { width: state.width, profile: state.profile }).map((product) => product.rim))
        : [];
      if (!rims.includes(state.rim)) state.rim = '';
      buildOptions(rimSelect, rims, placeholders.rim, state.rim, !(state.width && state.profile));

      const isComplete = Boolean(state.width && state.profile && state.rim);
      const matches = isComplete ? filterProducts(products, state) : [];
      submitButton.disabled = !isComplete || !matches.length;

      if (!state.width && !state.profile && !state.rim) {
        statusNode.textContent = '';
        submitButton.textContent = defaultButtonLabel;
      } else if (!isComplete) {
        statusNode.textContent = 'Completa la medida para ver resultados disponibles.';
        submitButton.textContent = defaultButtonLabel;
      } else if (!matches.length) {
        statusNode.textContent = 'No hay resultados para esa medida exacta. Revisa otra combinación.';
        submitButton.textContent = 'Sin resultados';
      } else {
        const measure = `${state.width}/${state.profile}-${state.rim}`;
        statusNode.replaceChildren();
        const message = document.createTextNode(matches.length === 1 ? 'Encontré 1 producto para ' : `Encontré ${matches.length} opciones para `);
        const strong = document.createElement('strong');
        strong.textContent = measure;
        statusNode.append(message, strong, document.createTextNode('.'));
        submitButton.textContent = matches.length === 1 ? 'Ver neumático' : `Ver ${matches.length} neumáticos`;
      }
    };

    widthSelect.addEventListener('change', () => {
      state.width = widthSelect.value;
      state.profile = '';
      state.rim = '';
      render();
    });
    profileSelect.addEventListener('change', () => {
      state.profile = profileSelect.value;
      state.rim = '';
      render();
    });
    rimSelect.addEventListener('change', () => {
      state.rim = rimSelect.value;
      render();
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const matches = filterProducts(products, state);
      if (!matches.length) return;
      if (matches.length === 1) {
        window.location.assign(matches[0].url);
        return;
      }
      const target = [`ancho-${state.width}`, `perfil-${state.profile}`, `aro-${state.rim}`].join('+');
      window.location.assign(collectionUrl ? `${collectionUrl}/${target}?sort_by=best-selling` : matches[0].url);
    });

    render();
  };

  const loadFinder = async (root) => {
    if (root.dataset.finderLoading === 'true' || root.dataset.finderReady === 'true') return;
    const collectionUrl = root.dataset.collectionUrl;
    if (!collectionUrl) return;

    root.dataset.finderLoading = 'true';
    try {
      const url = new URL(collectionUrl, window.location.origin);
      url.searchParams.set('view', 'mq-tire-data');
      const response = await fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Tire data request failed: ${response.status}`);
      initializeFinder(root, await response.json());
    } catch (error) {
      const status = root.querySelector('[data-tire-status]');
      if (status) status.textContent = 'No pudimos cargar las medidas. Revisa la colección completa.';
      root.setAttribute('aria-busy', 'false');
    } finally {
      root.dataset.finderLoading = 'false';
    }
  };

  const prepareFinder = (root) => {
    if (!root || root.dataset.finderBound === 'true' || !root.dataset.collectionUrl) return;
    root.dataset.finderBound = 'true';
    const activate = () => loadFinder(root);
    root.addEventListener('pointerdown', activate, { capture: true, once: true });
    root.addEventListener('focusin', activate, { capture: true, once: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        loadFinder(root);
      }, { rootMargin: '250px 0px' });
      observer.observe(root);
    } else {
      loadFinder(root);
    }
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('[data-tire-finder-root]').forEach(prepareFinder);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
